<template>
  <div class="TopicList w-full bg-white pb-2 lg:pb-8" id="topicList">
    <div v-if="topicData">
      <div class="item overflow-hidden border borderColordarkgray2 mb-5" v-for="(item, index) in topicData" :key="index" >
        <router-link :to="{name: 'topicDetail', params: {id: item.id}}" class="flex flex-wrap">
          <div class="w-full md:w-2/5 flex flex-col">
            <div class="article-cover overflow-hidden" v-if="item.cover_url">
              <img class="w-full h-full object-cover" :src="item.cover_url">
            </div>
            <div class="article-cover-none overflow-hidden" v-else>
              <img class="w-full h-full object-cover" v-lazy="require('@/assets/images/preset_item.png')">
            </div>
          </div>
          <div class="w-full md:w-3/5">
            <div class="introduction px-2 py-3 md:px-4 lg:py-4">
              <div class="text-lg lg:text-xl mb-2 lg:mb-3 text-black text-NotoSansBold">【{{ item.category_name }}】{{ item.title }}</div>
              <p class="textColorBlack text-base text-NotoSansRegular mb-4 lg:mb-6 leading-loose">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.
              </p>
              <!-- <div class="seemore w-full flex justify-center">
                <router-link class="button-gray cursor-pointer text-NotoSansRegular py-1 px-3 border borderColordarkgray"
                  :to="{name: 'topicDetail', params: {id: item.id}}" type="button">
                  See More
                </router-link>
              </div> -->
            </div>
          </div>
        </router-link>
        <!-- <router-link :to="{name: 'topicDetail', params: {id: item.id}}">
          <div class="article-cover" v-if="item.cover_url">
            <img class="w-full" :src="item.cover_url">
          </div>
          <div class="article-cover-none relative" v-else>
            <img class="w-full presetPhoto" src="~@/assets/images/preset_item.png">
          </div>
        </router-link>
        <div class="px-2 py-3 md:px-4 lg:px-8 lg:py-4">
          <div class="font-bold text-lg lg:text-xl mb-2 lg:mb-3 text-black text-NotoSansBold">【{{ item.category_name }}】{{ item.title }}</div>
          <p class="textColorBlack text-sm text-NotoSansRegular mb-4 lg:mb-6 introduction">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.
          </p>
          <div class="seemore w-full flex justify-center">
            <router-link class="button-gray cursor-pointer text-NotoSansRegular py-1 px-3 border borderColordarkgray"
              :to="{name: 'topicDetail', params: {id: item.id}}" type="button">
              See More
            </router-link>
          </div>
        </div> -->
      </div>
    </div>
    <div class="w-full loading" v-else>
      <vue-content-loading :width="300" :height="210" v-for="(item, index) in 5" :key="index">
        <rect cx="30" cy="30" width="300" r="30" height="150" x="0" />
        <rect cx="30" cy="80" r="50" x="0" y="160" rx="3" ry="3" width="300" height="5" />
        <rect cx="30" cy="80" r="50" x="0" y="170" rx="3" ry="3" width="300" height="5" />
        <rect cx="30" cy="80" r="50" x="0" y="180" rx="3" ry="3" width="300" height="5" />
        <rect cx="30" cy="80" r="50" x="120" y="190" rx="3" ry="3" width="50" height="10" />
      </vue-content-loading>
    </div>

    <PaginateComponent :pagination="pagination" v-on:pageChangeHandler="pageChangeHandler" />

  </div>
</template>

<script>
import axios from 'axios'
import VueContentLoading from 'vue-content-loading'
import PaginateComponent from '@/components/modules/Paginatation'
export default {
  name: 'ArticleList',
  metaInfo () {
    return {
      title: this.page_title
    }
  },
  data () {
    return {
      page_title: '主題專欄',

      topicData: null,

      // pagination
      pageNum: 5,
      pagination: {
        currentPage: 1,
        length: 2
      }
    }
  },
  components: {
    PaginateComponent,
    VueContentLoading
  },
  watch: {
    '$route' (to, from) {
      if (to.params.topicCategory !== from.params.topicCategory) {
        this.getData()
      }
    }
  },
  computed: {
  },
  mounted () {
    this.getData()
  },
  updated () {
  },
  methods: {
    getData () {
      let self = this
      self.topicData = null
      let listPath = '/articles?page=1&pageSize=10'
      if (self.$route.params.topicCategory) {
        listPath = `/articles?category=${self.$route.params.topicCategory}`
      }

      axios.get(listPath)
        .then((response) => {
          self.topicData = response.data.data
          self.pagination.length = response.data.last_page
        })
    },
    async pageChangeHandler (pageChangeHandler) {
      let self = this
      self.pagination.currentPage = pageChangeHandler
      self.getData()
    }
  }
}
</script>

<style lang="scss">
#topicList {
  .banner {
    height: 12.5rem;
  }
  .article-cover {
    height: 300px;
    overflow: hidden;
  }
  @media (max-width: 767px) {
    .article-cover {
      height: 200px;
    }
  }
  .article-cover-none {
    overflow: hidden;
    position: relative;
    height: 360px;
    width: 100%;
    border: solid 1px #ccc;
    .presetPhoto {
      position: absolute;
      top: -9999px;
      bottom: -9999px;
      left: -9999px;
      right: -9999px;
      margin: auto;
    }
  }
  @media (max-width: 426px) {
    .article-cover-none {
      height: 238px;
    }
  }
  @media (max-width: 376px) {
    .article-cover-none {
      height: 209px;
    }
  }
  // .introduction {
  //   overflow:hidden;
  //   white-space: nowrap;
  //   text-overflow: ellipsis;
  //   display: -webkit-box;
  //   -webkit-line-clamp: 1;
  //   -webkit-box-orient: vertical;
  //   white-space: normal;
  // }
  .introduction {
    max-height: 300px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    white-space: normal;
    position: relative;
    ::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0px;
      bottom: 0;
      width: 100%;
      height: 30% !important;
      background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      height: 100%;
      z-index: 1;
      transition: .2s;
    }
  }
  // @media (max-width: 1025px) {
  //   .introduction {
  //     overflow:hidden;
  //     white-space: nowrap;
  //     text-overflow: ellipsis;
  //     display: -webkit-box;
  //     -webkit-line-clamp: 2;
  //     -webkit-box-orient: vertical;
  //     white-space: normal;
  //   }
  // }
  .item-content {
    flex-direction: column;
    font-size: 20px;
    color: #686868;
    box-sizing: border-box;
  }
  .article-img:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0px;
    right: 0px;
    background: rgba(0, 0, 0, 0.1);
    height: 100%;
    z-index: 1;
    transition: .2s;
  }
  .article-img:hover:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0px;
    right: 0px;
    background: rgba(0, 0, 0, 0.5);
    height: 100%;
    z-index: 1;
  }
  .btn {
    transition: .2s;
  }
  .top {
    position: fixed;
    right: 1rem;
    bottom: 2rem;
  }
  @media (max-width: 768px) {
    .top {
      right: .8rem;
      bottom: 3.5rem;
    }
  }
  .text {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
